// Colours START
export const SP_DARK_BLUE = "#063266";
export const EMC_RED = "#F03A36";
export const LINE_GRAPH_PALETTE = [
  SP_DARK_BLUE, EMC_RED, "#6DA3B6", "#036704", "#79579b",
];
export const LIGHT_PALETTE = [
  "#6929c4", "#1192e8", "#005d5d", "#9f1853", "#fa4d56", "#570408", "#198038",
  "#002d9c", "#ee538b", "#b28600", "#009d9a", "#012749", "#8a3800", "#a56eff",
];
// Colours END

// Units START
export const DEMAND_UNIT = "MW";
export const TEMPERATURE_UNIT = "°C";
// Units END